import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";

function FormConsentContainerPreview({ children, ...props }) {
  return <BasePreview {...props}>
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('form-consent-instructions-container', FormConsentContainerPreview, Fragment)
  .shared(prop.share('FormConsentContainer', 'form-consent-instructions-container'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    space: {
      padding: "p-1",
    },
    background: {
      color: {
        default: null,
        "[[data-status=error]_&]": "red-100",
        "[[data-status=checked]_&]": "green-100",
      },
    },
    border: {
      color: {
        default: "gray-400",
        "[[data-status=error]_&]": "red-100",
        "[[data-status=checked]_&]": "green-100",
      },
      width: {
        default: { border: "1" },
        "[[data-status=error]_&]": { border: "1" },
        "[[data-status=checked]_&]": { border: "1" },
      },
      radius: {
        rounded: "sm",
      },
    },
  })
  .build()
